<template>
  <div>
    <nx-dialog
      :visible.sync="show"
      :title="{ add: '新增', edit: '编辑', detail: '详情' }[type]"
      width="750px"
      :before-close="beforeClose"
      @onConfirm="onConfirm"
    >
      <nx-form ref="submitForm" :source="submitForm" :config="submitConfig"></nx-form>
    </nx-dialog>
  </div>
</template>
<script>
import ChipModelSelect from '../../components/chipModelSelect.vue';
import { updateTerminalModel, getDetailById } from '@/api/notRoadFour/terminalModel';

export default {
  name: '',
  components: {},
  props: {
    visible: {
      type: Boolean,
    },
    id: {
      type: [String, Number],
      default: () => '',
    },
    type: {
      type: String,
      default: () => '',
    },
    recordResult: {
      type: [String, Number],
      default: () => '',
    },
  },
  data() {
    return {
      show: false,
      submitForm: {
        tboxModel: '', // 终端型号
        tboxFactoryName: '', // 生产企业名称
        tboxFactoryId: '', // 生产企业机构代码
        chipFactoryNote: '', // 生产企业说明
        contactorName: '', // 联系人姓名
        contactorPhone: '', // 联系人电话
        chipModel: '', // 芯片型号
        reportImgId: '', // 终端检测报告编号
        tboxFactoryLicenceImgValue: '', // 营业执照
        reportImgValue: '', // 终端检测报告扫描件
        authorizeFileValue: '', // 授权文件
      },
    };
  },
  computed: {
    submitConfig() {
      return [
        {
          key: 'tboxModel',
          component: 'el-input',
          span: 12,
          label: '终端型号:',
          props: {
            placeholder: '请输入终端型号',
            maxlength: 30,
             disabled: this.recordResult === 4 ? true : false,
          },
          itemProps: {
            rules: [
              { required: true, message: '请输入终端型号', trigger: 'blur' },
              {
                validator: (rule, value, callback) => {
                  if (this.$validate.hasSpace(value)) {
                    return callback(new Error('不能输入空格'));
                  }
                  callback();
                },
                trigger: 'blur',
              },
            ],
          },
        },
        {
          key: 'tboxFactoryName',
          component: 'el-input',
          span: 12,
          labelWidth: '130px',
          label: '生产企业名称:',
          props: {
            placeholder: '请输入生产企业名称',
            maxlength: 30,
          },
          itemProps: {
            rules: [
              { required: true, message: '请输入生产企业名称', trigger: 'blur' },
              {
                validator: (rule, value, callback) => {
                  if (this.$validate.hasSpace(value)) {
                    return callback(new Error('不能输入空格'));
                  }
                  callback();
                },
                trigger: 'blur',
              },
            ],
          },
        },
        {
          key: 'tboxFactoryId',
          component: 'el-input',
          span: 12,
          label: '机构代码:',
          props: {
            placeholder: '请输入生产企业机构代码',
            maxlength: 30,
             disabled: this.recordResult === 4 ? true : false
          },
          itemProps: {
            rules: [
              { required: true, message: '请输入生产企业机构代码', trigger: 'blur' },
              {
                validator: (rule, value, callback) => {
                  if (this.$validate.hasSpace(value)) {
                    return callback(new Error('不能输入空格'));
                  }
                  callback();
                },
                trigger: 'blur',
              },
            ],
          },
        },
        {
          key: 'chipFactoryNote',
          component: 'el-input',
          span: 12,
          labelWidth: '130px',
          label: '生产企业说明:',
          props: {
            placeholder: '请输入生产企业说明',
            maxlength: 30,
             disabled: this.recordResult === 4 ? true : false
          },
          itemProps: {
            rules: [
              { required: true, message: '请输入生产企业说明', trigger: 'blur' },
              {
                validator: (rule, value, callback) => {
                  if (this.$validate.hasSpace(value)) {
                    return callback(new Error('不能输入空格'));
                  }
                  callback();
                },
                trigger: 'blur',
              },
            ],
          },
        },
        {
          key: 'contactorName',
          component: 'el-input',
          span: 12,
          label: '联系人姓名:',
          props: {
            placeholder: '请输入联系人姓名',
            maxlength: 20,
             disabled: this.recordResult === 4 ? true : false,
          },
          itemProps: {
            rules: [
              { required: true, message: '请输入联系人姓名', trigger: 'blur' },
              {
                validator: (rule, value, callback) => {
                  if (this.$validate.hasSpace(value)) {
                    return callback(new Error('不能输入空格'));
                  }
                  callback();
                },
                trigger: 'blur',
              },
            ],
          },
        },
        {
          key: 'contactorPhone',
          component: 'el-input',
          span: 12,
          labelWidth: '130px',
          label: '联系人电话:',
          props: {
            placeholder: '请输入联系人电话',
            maxlength: 11,
             disabled: this.recordResult === 4 ? true : false,
          },
          itemProps: {
            rules: [
              { required: true, message: '请输入联系人电话', trigger: 'blur' },
              {
                validator: (rule, value, callback) => {
                  if (this.$validate.hasSpace(value)) {
                    return callback(new Error('不能输入空格'));
                  }
                  if (this.$validate.isPhone(value)) {
                    return callback();
                  }
                  return callback(new Error('请输入正确的手机号码'));
                },
                trigger: 'blur',
              },
            ],
          },
        },
        {
          key: 'chipModel',
          component: ChipModelSelect,
          span: 12,
          label: '芯片型号:',
          props: {
            placeholder: '请输入终端型号',
            maxlength: 30,
             disabled: this.recordResult === 4 ? true : false
          },
        },
        {
          key: 'reportImgId',
          component: 'el-input',
          labelWidth: '130px',
          span: 12,
          label: '终端检测报告编号:',
          props: {
            placeholder: '请输入终端型号',
            maxlength: 30,
             disabled: this.recordResult === 4 ? true : false,
          },
        },
        {
          key: 'tboxFactoryLicenceImgValue',
          component: 'nx-upload',
          span: 24,
          label: '企业营业执照:',
          props: {
            placeholder: '请选择jpg文件格式上传，大小不超过2M',
            size: 2,
            obsType: 'transfer',
            reg: /.(jpg)$/,
             disabled: this.recordResult === 4 ? true : false,
             canOperate: this.type !== 'detail',
          },
          itemProps: {
            rules: [{ required: true, message: '请上传企业营业执照', trigger: 'blur' }],
          },
          tips: '请选择jpg文件格式上传，大小不超过2M',
        },
        {
          key: 'reportImgValue',
          component: 'nx-upload',
          span: 24,
          label: '终端检测报告扫描件:',
          props: {
            placeholder: '请选择jpg文件格式上传，大小不超过2M',
            size: 2,
            obsType: 'transfer',
            reg: /.(jpg)$/,
            disabled: this.recordResult === 4 ? true : false,
            canOperate: this.type !== 'detail',
          },
          // itemProps: {
          //   rules: [
          //     { required: true, message: '请上传终端检测报告扫描件', trigger: 'blur' }
          //   ]
          // },
          tips: '请选择jpg文件格式上传，大小不超过2M',
        },
        {
          key: 'authorizeFileValue',
          component: 'nx-upload',
          props: {
            placeholder: '请选择jpg文件格式上传，大小不超过2M',
            size: 2,
            obsType: 'transfer',
            reg: /.(jpg)$/,
             canOperate: this.type !== 'detail',
          },
          span: 24,
          label: '授权文件:',
          itemProps: {
            rules: [{ required: true, message: '请上传授权文件', trigger: 'blur' }],
          },
          tips: '请选择jpg文件格式上传，大小不超过2M',
        },
      ];
    },
  },
  watch: {
    visible: {
      handler(visible) {
        this.show = visible;
      },
    },
    show: {
      handler(show) {
        if (show && this.id) {
          this.getDetailById(this.id);
        }
        this.$emit('update:visible', show);
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    async getDetailById(id) {
      const { data } = await getDetailById(id);
      this.submitForm = {
        ...this.$utils.extractMerge(this.submitForm, data),
        id
      };
    },
    async onConfirm() {
      if (this.type != 'detail') {
        const valid = await this.$refs.submitForm.validate();
        if (!valid) return;
        const params = {
          ...this.submitForm,
        };
        await updateTerminalModel(params);
        this.$message.success('操作成功');
        this.$emit('onConfirm');
      }
      this.show = false;
    },
    beforeClose(done) {
      this.$refs.submitForm.resetFields();
      delete this.submitForm.id;
      done();
    },
  },
};
</script>
<style scoped lang="scss"></style>
